var map = {
	"./Baltic_Main.jpg": 344,
	"./Chimera_Main.jpg": 345,
	"./Desert_Main.jpg": 346,
	"./DihorOtok_Main.jpg": 347,
	"./Erangel_Main.jpg": 348,
	"./Heaven_Main.jpg": 349,
	"./Kiki_Main.jpg": 350,
	"./Neon_Main.jpg": 351,
	"./Savage_Main.jpg": 352,
	"./Summerland_Main.jpg": 353,
	"./Tiger_Main.jpg": 354
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 343;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*\.jpg$
// module id = 343
// module chunks = 0